export default {
	Event: 'event',
	VirtualPageURL: 'virtualPageUrl',
	VirtualPageTitle: 'virtualPageTitle',
};
